import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const TrainingDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingStudentILTrainingDetails" */ 'modules/simulatorTrainings/student/instructorLed/TrainingDetails/pages/TrainingDetails'
    )
)

const TrainingDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:scheduleId`} component={TrainingDetails} />
      <Redirect path='*' to={simulatorTrainingRoutes.root} />
    </Switch>
  </Suspense>
)

export default TrainingDetailsRouting
